webpackJsonp(["pages.projects.branches.index"],{

/***/ "./ajax_loading_spinner.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AjaxLoadingSpinner = function () {
  function AjaxLoadingSpinner() {
    _classCallCheck(this, AjaxLoadingSpinner);
  }

  _createClass(AjaxLoadingSpinner, null, [{
    key: 'init',
    value: function init() {
      var $elements = $('.js-ajax-loading-spinner');

      $elements.on('ajax:beforeSend', AjaxLoadingSpinner.ajaxBeforeSend);
      $elements.on('ajax:complete', AjaxLoadingSpinner.ajaxComplete);
    }
  }, {
    key: 'ajaxBeforeSend',
    value: function ajaxBeforeSend(e) {
      e.target.setAttribute('disabled', '');
      var iconElement = e.target.querySelector('i');
      // get first fa- icon
      var originalIcon = iconElement.className.match(/(fa-)([^\s]+)/g)[0];
      iconElement.dataset.icon = originalIcon;
      AjaxLoadingSpinner.toggleLoadingIcon(iconElement);
      $(e.target).off('ajax:beforeSend', AjaxLoadingSpinner.ajaxBeforeSend);
    }
  }, {
    key: 'ajaxComplete',
    value: function ajaxComplete(e) {
      e.target.removeAttribute('disabled');
      var iconElement = e.target.querySelector('i');
      AjaxLoadingSpinner.toggleLoadingIcon(iconElement);
      $(e.target).off('ajax:complete', AjaxLoadingSpinner.ajaxComplete);
    }
  }, {
    key: 'toggleLoadingIcon',
    value: function toggleLoadingIcon(iconElement) {
      var classList = iconElement.classList;
      classList.toggle(iconElement.dataset.icon);
      classList.toggle('fa-spinner');
      classList.toggle('fa-spin');
    }
  }]);

  return AjaxLoadingSpinner;
}();

/* harmony default export */ __webpack_exports__["a"] = (AjaxLoadingSpinner);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./branches/branches_delete_modal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODAL_SELECTOR = '#modal-delete-branch';

var DeleteModal = function () {
  function DeleteModal() {
    _classCallCheck(this, DeleteModal);

    this.$modal = $(MODAL_SELECTOR);
    this.$toggleBtns = $('[data-target="' + MODAL_SELECTOR + '"]');
    this.$branchName = $('.js-branch-name', this.$modal);
    this.$confirmInput = $('.js-delete-branch-input', this.$modal);
    this.$deleteBtn = $('.js-delete-branch', this.$modal);
    this.$notMerged = $('.js-not-merged', this.$modal);
    this.bindEvents();
  }

  _createClass(DeleteModal, [{
    key: 'bindEvents',
    value: function bindEvents() {
      this.$toggleBtns.on('click', this.setModalData.bind(this));
      this.$confirmInput.on('input', this.setDeleteDisabled.bind(this));
    }
  }, {
    key: 'setModalData',
    value: function setModalData(e) {
      var branchData = e.currentTarget.dataset;
      this.branchName = branchData.branchName || '';
      this.deletePath = branchData.deletePath || '';
      this.isMerged = !!branchData.isMerged;
      this.updateModal();
    }
  }, {
    key: 'setDeleteDisabled',
    value: function setDeleteDisabled(e) {
      this.$deleteBtn.attr('disabled', e.currentTarget.value !== this.branchName);
    }
  }, {
    key: 'updateModal',
    value: function updateModal() {
      this.$branchName.text(this.branchName);
      this.$confirmInput.val('');
      this.$deleteBtn.attr('href', this.deletePath);
      this.$deleteBtn.attr('disabled', true);
      this.$notMerged.toggleClass('hidden', this.isMerged);
    }
  }]);

  return DeleteModal;
}();

/* harmony default export */ __webpack_exports__["a"] = (DeleteModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./pages/projects/branches/index/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ajax_loading_spinner__ = __webpack_require__("./ajax_loading_spinner.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__branches_branches_delete_modal__ = __webpack_require__("./branches/branches_delete_modal.js");



document.addEventListener('DOMContentLoaded', function () {
  __WEBPACK_IMPORTED_MODULE_0__ajax_loading_spinner__["a" /* default */].init();
  new __WEBPACK_IMPORTED_MODULE_1__branches_branches_delete_modal__["a" /* default */](); // eslint-disable-line no-new
});

/***/ })

},["./pages/projects/branches/index/index.js"]);


// WEBPACK FOOTER //
// pages.projects.branches.index.d4b6c76e4b318428ffd6.bundle.js